module.exports = __webpack_public_path__ + "static/img/lineweight.c59d40bb.png";